import type { ReactNode } from 'react';

export function hasRenderableNode(node: ReactNode): boolean {
  if (node === null || node === undefined || typeof node === 'boolean') {
    return false;
  }

  if (Array.isArray(node)) {
    return node.some(hasRenderableNode);
  }

  return node !== '';
}
